import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { FormsModule } from '@angular/forms'
import { A11yModule } from '@angular/cdk/a11y'
import { MatDialogModule } from '@angular/material/dialog'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatSelectModule } from '@angular/material/select'

import { MacropointSegmentConfirmDialogComponent } from './macropoint-segment-confirm-dialog.component'

@NgModule({
  declarations: [MacropointSegmentConfirmDialogComponent],
  imports: [
    CommonModule,
    FormsModule,
    A11yModule,
    MatDialogModule,
    MatFormFieldModule,
    MatSelectModule,
  ],
  exports: [MacropointSegmentConfirmDialogComponent],
})
export class MacropointSegmentConfirmDialogModule {}
